import React from 'react';
import { BlueBadge } from '../../../components/Badge/Badge';
import ButtonApi from '../../../components/ButtonApi';
import { Flexbox, FlexboxColumn } from '../../../components/action/Flexbox';
import LoginButton from '../../../components/login/LoginButton';
import ThemeLogo from '../../../components/theme/ThemeLogo';
import ThemedText from '../../../components/theme/ThemedText';
import { formatPopulation } from '../../../utils';

const Details = ({ handleClose, onNext, worldData }) => {
  function getPopulationForContinent() {
    if (!worldData?.countries) {
      return 0;
    }
    if (worldData?.countries?.length < 4) return 0;

    const totalPopulation = worldData?.countries?.slice(3)?.reduce((total, country) => {
      const population = parseInt(country.population.replace(/,/g, ''), 10); // Convert population to number
      return total + population;
    }, 0);

    return totalPopulation.toLocaleString();
  }

  function getWholePopulation() {
    if (!worldData?.countries) {
      return 0;
    }

    const totalPopulation = worldData?.countries?.reduce((total, country) => {
      const population = parseInt(country.population.replace(/,/g, ''), 10); // Convert population to number
      return total + population;
    }, 0);

    return totalPopulation;
  }
  const SLOTS = {
    Asia: 1000,
    Africa: 300,
    Europe: 200,
    'North America': 200,
    'South America': 200,
    Oceania: 30,
  };

  return (
    <>
      <div className='image_container'>
        <Flexbox gap='0.75rem'>
          <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              opacity='0.4'
              d='M12.7496 34.8499C12.6996 34.8499 12.6329 34.8833 12.5829 34.8833C9.34961 33.2833 6.71628 30.6333 5.09961 27.3999C5.09961 27.3499 5.13294 27.2833 5.13294 27.2333C7.16628 27.8333 9.26628 28.2833 11.3496 28.6333C11.7163 30.7333 12.1496 32.8166 12.7496 34.8499Z'
              fill='#314DDF'
            />
            <path
              opacity='0.4'
              d='M34.9004 27.4166C33.2504 30.7333 30.5004 33.4166 27.1504 35.0333C27.7837 32.9166 28.3171 30.7833 28.6671 28.6333C30.7671 28.2833 32.8337 27.8333 34.8671 27.2333C34.8504 27.2999 34.9004 27.3666 34.9004 27.4166Z'
              fill='#314DDF'
            />
            <path
              opacity='0.4'
              d='M35.0337 12.85C32.9337 12.2167 30.8171 11.7 28.6671 11.3333C28.3171 9.18334 27.8004 7.05001 27.1504 4.96667C30.6004 6.61667 33.3837 9.40001 35.0337 12.85Z'
              fill='#314DDF'
            />
            <path
              opacity='0.4'
              d='M12.7501 5.14998C12.1501 7.18331 11.7168 9.24998 11.3668 11.35C9.2168 11.6833 7.08346 12.2166 4.9668 12.85C6.58346 9.49998 9.2668 6.74998 12.5835 5.09998C12.6335 5.09998 12.7001 5.14998 12.7501 5.14998Z'
              fill='#314DDF'
            />
            <path
              d='M25.8169 10.9834C21.9503 10.55 18.0503 10.55 14.1836 10.9834C14.6003 8.70004 15.1336 6.41671 15.8836 4.21671C15.9169 4.08337 15.9003 3.98337 15.9169 3.85004C17.2336 3.53337 18.5836 3.33337 20.0003 3.33337C21.4003 3.33337 22.7669 3.53337 24.0669 3.85004C24.0836 3.98337 24.0836 4.08337 24.1169 4.21671C24.8669 6.43337 25.4003 8.70004 25.8169 10.9834Z'
              fill='#314DDF'
            />
            <path
              d='M10.984 25.8167C8.68398 25.4 6.41732 24.8667 4.21732 24.1167C4.08398 24.0833 3.98398 24.1 3.85065 24.0833C3.53398 22.7667 3.33398 21.4167 3.33398 20C3.33398 18.6 3.53398 17.2333 3.85065 15.9333C3.98398 15.9167 4.08398 15.9167 4.21732 15.8833C6.43398 15.15 8.68398 14.6 10.984 14.1833C10.5673 18.05 10.5673 21.95 10.984 25.8167Z'
              fill='#314DDF'
            />
            <path
              d='M36.6676 20C36.6676 21.4167 36.4676 22.7667 36.1509 24.0833C36.0176 24.1 35.9176 24.0833 35.7842 24.1167C33.5676 24.85 31.3009 25.4 29.0176 25.8167C29.4509 21.95 29.4509 18.05 29.0176 14.1833C31.3009 14.6 33.5842 15.1333 35.7842 15.8833C35.9176 15.9167 36.0176 15.9333 36.1509 15.9333C36.4676 17.25 36.6676 18.6 36.6676 20Z'
              fill='#314DDF'
            />
            <path
              d='M25.8169 29.0167C25.4003 31.3167 24.8669 33.5834 24.1169 35.7834C24.0836 35.9167 24.0836 36.0167 24.0669 36.1501C22.7669 36.4667 21.4003 36.6667 20.0003 36.6667C18.5836 36.6667 17.2336 36.4667 15.9169 36.1501C15.9003 36.0167 15.9169 35.9167 15.8836 35.7834C15.1503 33.5667 14.6003 31.3167 14.1836 29.0167C16.1169 29.2334 18.0503 29.3834 20.0003 29.3834C21.9503 29.3834 23.9003 29.2334 25.8169 29.0167Z'
              fill='#314DDF'
            />
            <path
              d='M26.2729 26.2723C22.1044 26.7982 17.8969 26.7982 13.7284 26.2723C13.2025 22.1038 13.2025 17.8963 13.7284 13.7278C17.8969 13.2019 22.1044 13.2019 26.2729 13.7278C26.7988 17.8963 26.7988 22.1038 26.2729 26.2723Z'
              fill='#314DDF'
            />
          </svg>

          <ThemedText.h2  weight='semi-bold'>{worldData?.continent}</ThemedText.h2>
        </Flexbox>
        <div className='cross_logo' onClick={handleClose}>
          <svg xmlns='http://www.w3.org/2000/svg' width='27' height='26' viewBox='0 0 27 26' fill='none'>
            <g clip-path='url(#clip0_210_11821)'>
              <path d='M13.6279 15.4019L8.18553 20.8443L6.63087 19.2897L13.6279 12.2926L20.625 19.2897L19.0703 20.8443L13.6279 15.4019Z' fill='white' />
              <path d='M13.6221 11.5623L19.0645 6.11987L20.6191 7.67453L13.6221 14.6716L6.625 7.67453L8.17966 6.11987L13.6221 11.5623Z' fill='white' />
            </g>
            <defs>
              <clipPath id='clip0_210_11821'>
                <rect width='25.6552' height='25.6552' fill='white' transform='translate(0.966797 0.223633)' />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <Flexbox fw gap='2rem' justifyContent='flex-start'>
        <Flexbox gap='0.35rem'>
          <ThemeLogo icon={'map'} />
          <ThemedText.h5 weight='semi-bold'>{worldData?.countries?.length}</ThemedText.h5>
          <ThemedText.h5>Countries</ThemedText.h5>
        </Flexbox>
        <Flexbox gap='0.35rem'>
          <ThemeLogo icon={'people'} />
          <ThemedText.h5 weight='semi-bold'>{formatPopulation(Number(getWholePopulation()))}</ThemedText.h5>
          <ThemedText.h5>Population</ThemedText.h5>
        </Flexbox>
      </Flexbox>

      <FlexboxColumn fw alignItems={'flex-start'}>
        <ThemedText.h4 weight='medium'>Top Countries</ThemedText.h4>
        <table>
          {worldData?.countries?.slice(0, 3)?.map(country => (
            <tr>
              <td className='country_name'>{country?.country}</td>
              <td>{country?.population}</td>
            </tr>
          ))}
          {worldData?.countries?.length > 4 && (
            <tr>
              <td className='country_name'>Others</td>
              <td>{getPopulationForContinent()}</td>
            </tr>
          )}
        </table>
      </FlexboxColumn>

      <FlexboxColumn fw alignItems={'flex-start'} gap='0.75rem' justifyContent={'flex-start'} style={{ height: '100%' }}>
        <ThemedText.h4 weight='medium'>Application Details</ThemedText.h4>
        <Flexbox fw justifyContent='space-between'>
          <Flexbox gap='0.35rem'>
            <ThemeLogo icon={'badge'} />
            <ThemedText.h5 weight='semi-bold'>{SLOTS[worldData?.continent]}</ThemedText.h5>
            <ThemedText.h5>Open Slots</ThemedText.h5>
          </Flexbox>
          <BlueBadge text={'Post Waitlist'} />
        </Flexbox>

        <ThemedText.p className='country_info'>
          There are 4.8 billion humans on Earth, and we wanted to cover maximum regional diversity during the starting phase of the network, we'd be taking and processing
          applications on the basis of continents. We'd be roughly taking 1 person for every 5M people in a continent.
        </ThemedText.p>
        <ThemedText.h5 weight='medium' className='read_more'>
          More details about the application process will be shared once you get selected.
        </ThemedText.h5>
      </FlexboxColumn>
      <LoginButton content={<ButtonApi onClick={onNext}>{'Next'}</ButtonApi>} />
    </>
  );
};

export default Details;
